import request from '@/utils/request'

export const getUserInfo = (data: any) =>
  request.service({
    url: '/users/info',
    method: 'post',
    data
  })

export const login = (data: any) =>
  request.service({
    url: '/users/login',
    method: 'post',
    data
  })

export const logout = () =>
  request.service({
    url: '/users/logout',
    method: 'post'
  })
